import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Main from './pages/Main';
import ComingSoon from './pages/ComingSoon';
import Summary from './features/report/pages/Summary';
import MainLayout from './layout/components/MainLayout';
import TemplateReport from './features/report/pages/TemplateReport';
import DetailsReport from './features/report/pages/DetailsReport';
import NumberSearch from './features/report/pages/NumberSearch';
import Payments from './features/report/pages/Payments';
import UserFlowResponsesReport from './features/report/pages/UserFlowResponsesReport';
import SendTemplate from './features/campaign/pages/SendTemplate';
import Messages from './features/chat/pages/MessagesList';
import LiveChat from './features/chat/pages/LiveChat';
import Templates from './features/templates/pages/Templates';
import CreateTemplate from './features/templates/pages/CreateTemplate';
import SwaggerPage from './features/api/pages/SwaggerPage';
import AdminRoute from './features/admin/components/AdminRoute';
import CreateUser from './features/admin/pages/CreateUser';
import ManageUsers from './features/admin/pages/ManageUsers';
import AddBalance from './features/admin/pages/AddBalance';
import MessageStatsOverview from './features/admin/pages/MessageStatsOverview';

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/main" element={<MainLayout />}>
        <Route index element={<Main />} />
        <Route path="Dashboard" element={<Main />} />
        <Route path="templates" element={<Templates />} />
        <Route path="summary" element={<Summary />} />
        <Route path="details_report" element={<DetailsReport />} />
        <Route path="number_message_report" element={<NumberSearch />} />
        <Route path="user_payments_report" element={<Payments />} />
        <Route path="user_flow_responses_report" element={<UserFlowResponsesReport />} />
        <Route path="template_report" element={<TemplateReport />} />
        <Route path="template-report" element={<TemplateReport />} />
        <Route path="send-template" element={<SendTemplate />} />
        <Route path="create-template" element={<CreateTemplate />} />
        <Route path="Messages" element={<Messages />} />
        <Route path="chat" element={<LiveChat />} />
        <Route path="chat/:waid" element={<LiveChat />} />
        <Route path="swagger" element={<SwaggerPage />} />
        <Route path="under_construction" element={<ComingSoon />} />
        <Route path="site_construction" element={<ComingSoon />} />
        <Route path="site_comming_soon" element={<ComingSoon />} />
        <Route path="site_under_construction" element={<ComingSoon />} />
        <Route
          path="admin/overview"
          element={
            <AdminRoute>
              <MessageStatsOverview />
            </AdminRoute>
          }
        />
        <Route
          path="admin/create-user"
          element={
            <AdminRoute>
              <CreateUser />
            </AdminRoute>
          }
        />
        <Route
          path="admin/manage-users"
          element={
            <AdminRoute>
              <ManageUsers />
            </AdminRoute>
          }
        />
        <Route
          path="admin/add-balance"
          element={
            <AdminRoute>
              <AddBalance />
            </AdminRoute>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

export default App;
